import React from 'react';

const ClosedEyeIcon = () => (
    <svg className="svg-icon closed-eye-icon" width="16px" height="14px" viewBox="12 13 16 14"
        xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
        <g className="theme-path" fillRule="evenodd" transform="translate(0.000000, 0.000000)">
            <path d="M16.4046216,23.1624477 C14.0424228,21.9926939 12.3400938,19.7062343 12,17 L14.036823,
            17 C14.3736488,18.9921524 15.6998162,20.6514258 17.4968772,21.4633834 L22.9376237,13 L24.9376237,
            13 L15.9376237,27 L13.9376237,27 L16.4046216,23.1624477 Z M20.8977169,23.9509661 L22.4943281,
            21.4673486 C24.2958562,20.6568362 25.625802,18.9954008 25.963177,17 L28,17 C27.5406678,
            20.6550517 24.5964388,23.5443791 20.8977169,23.9509661 Z">
            </path>
        </g>
    </svg>
);

export default ClosedEyeIcon;
